import { Box } from "@mui/material"
import { FC } from "react"

const ErrorPage: FC = () => {
    return <Box>Error</Box>
}

export default ErrorPage